import { render, staticRenderFns } from "./SiteBans.vue?vue&type=template&id=5c251f90&scoped=true"
import script from "./SiteBans.vue?vue&type=script&lang=js"
export * from "./SiteBans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c251f90",
  null
  
)

export default component.exports